export enum WorkTimeType {
    REGULAR = 'REGULAR' as any,
    RAMADAN = 'RAMADAN' as any
}
